// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"486":"5dbcedebab2fc5b16437","816":"eb6507d2104f7b42c1d9","2915":"aeb644abd5559dc07cea"}[chunkId] + ".css";
};